function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "svg-path",
    d: "M23.9746 0H8C3.60635 0 0 3.60635 0 8.0254V24C0 28.3937 3.60635 32 8 32H23.9746C28.3937 32 32 28.3937 32 23.9746V8.0254C32 3.60635 28.3937 0 23.9746 0ZM20.2921 16H17.2698V25.9048H13.4603V16H11.4286V11.9365H13.2064V10.2095C13.2064 8.58413 14.019 6.01905 17.4476 6.01905H20.5714V9.39683H18.3619C18.0064 9.39683 17.5238 9.6254 17.5238 10.4127V11.9365H20.6476L20.2921 16Z",
    fill: "#50429B",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedFb);
export default __webpack_public_path__ + "static/media/linked-fb.2ccffa2d3e079c3c8ae45cf8bb368c2e.svg";
export { ForwardRef as ReactComponent };